// Copyright 2018 Sorama B.V.

import { bindable, customElement } from "aurelia-framework";
import { DrawLayer, Margin, Pair, Rect, Size } from "controls/plot/IPlotPart";
import { PlotPartBase } from "controls/plot/PlotPartBase";
import { Unit } from "units/Unit";
import { IPlotParent } from "../IPlotParent";

@customElement("background-mjpeg-part")
export class BackgroundMJPEGPart extends PlotPartBase {
    //#region fields
    @bindable public uri: string;

    private static InstanceCounter = 0;

    private zoomFactorX: number;
    private zoomFactorY: number;
    private xZoomOffset: number;
    private yZoomOffset: number;
    private translateX: number;
    private translateY: number;

    //#region Constructor and Initialisation
    constructor() {
        super(0, DrawLayer.Background);
    }

    public bind(context: IPlotParent): void {
        super.bind(context);
    }

    public onMeasureMargin(): Margin {
        // No extra margin required
        return new Margin(0, 0, 0, 0);
    }

    public onSize(size: Size, margin: Margin): void {
        super.onSize(size, margin);

        // Wait before setting the size until we get a valid size
        this.size = size;
        this.margin = margin;

        this.zoomFactorX = 1;
        this.zoomFactorY = 1;

        this.translateX = 0;
        this.translateY = 0;
    }

    public onViewPortComputed(viewPort: Rect, viewPortBounds: Rect, units: Pair<Unit>): void {
        super.onViewPortComputed(viewPort, viewPortBounds, units);

        if (!this.actualSize) return;

        this.zoomFactorX = this.viewPortBounds.width / this.viewPort.width;
        this.zoomFactorY = this.viewPortBounds.height / this.viewPort.height;

        const xOffset = this.viewPort.x - this.viewPortBounds.x;
        this.xZoomOffset = (this.viewPortBounds.width - this.viewPortBounds.width / this.zoomFactorX) / 2;
        this.translateX = ((this.xZoomOffset - xOffset) / this.viewPortBounds.width) * this.actualSize.width;

        const yOffset = this.viewPort.y - this.viewPortBounds.y;
        this.yZoomOffset = (this.viewPortBounds.height - this.viewPortBounds.height / this.zoomFactorY) / 2;
        this.translateY = ((yOffset - this.yZoomOffset) / this.viewPortBounds.height) * this.actualSize.height;
    }
}
